import { createSelector } from 'reselect';
import { simplifyFiltersOnPLPSelector } from 'selectors/testTarget/offers/simplifyFiltersOnPLP/simplifyFiltersOnPLPSelector';

export const showSelector = createSelector(
    simplifyFiltersOnPLPSelector,
    simplifyFiltersOnPLP => simplifyFiltersOnPLP.show
);
